import { apiClient } from './client';
export const contactsApi = {
    lookupByLinkedInUrl: (linkedInUrl, opts, signal) => {
        const encoded = encodeURIComponent(linkedInUrl.trim());
        const params = [`linkedinUrl=${encoded}`];
        const includes = [];
        if (opts?.includeCompanies)
            includes.push('companies');
        if (opts?.includeSchools)
            includes.push('schools');
        if (includes.length)
            params.push(`includes=${includes.join(',')}`);
        const qs = params.join('&');
        return apiClient.get(`/api/Contacts/lookup?${qs}`, { signal });
    },
    lookupByContactId: (contactId, opts) => {
        const safeId = encodeURIComponent(contactId.trim());
        const includes = [];
        if (opts?.includeCompanies)
            includes.push('companies');
        if (opts?.includeSchools)
            includes.push('schools');
        const qs = includes.length ? `?includes=${includes.join(',')}` : '';
        return apiClient.get(`/api/Contacts/${safeId}/lookup${qs}`);
    }
};
